import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=05af98ca&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=05af98ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af98ca",
  null
  
)

export default component.exports